export default (x, y, width, height /*, color*/) =>
  `<?xml version="1.0" encoding="iso-8859-1"?> <svg xmlns="http://www.w3.org/2000/svg" x="${x}" y="${y}" width="${width}" height="${height}" viewBox="0 0 24 24" fill="none">
<path d="M12 5V11M12 14V15.5M12 18.5V19" stroke="#3D4B52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 11L12 5" stroke="#3D4B52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6 11L12 5" stroke="#3D4B52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
